import styled, { css } from 'styled-components'
// views
import { SelectWrapper } from 'components/FormElements/Select/views'
import { ButtonsWrapper } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
import { ClockIconButton } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/RiskTemplateField/components/HistoryButton'
import { AiButtonsWrapper } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/AiControlButton/views'
// themes
import { colors } from 'themes'
// utils
import { isColorLight } from 'utils/tree'

export const FieldWrapper = styled.div<{
  $color: string | undefined
  $isError: boolean
  $isSwitch: boolean
  $isMatrix: boolean
  $isRiskTemplate: boolean
  $isRecordLinks?: boolean
  $historyEnabled: boolean
}>`
  align-items: center;
  background-color: ${({ $isRiskTemplate }) => ($isRiskTemplate ? colors.gray190 : 'unset')};
  border-radius: 4px;
  display: flex;
  gap: 12px;
  height: auto;
  min-height: 64px;
  padding: 8px ${({ $isRiskTemplate }) => ($isRiskTemplate ? '12px' : '0')};
  position: relative;

  :first-child {
    margin-top: 0;
  }

  & > div:first-of-type {
    width: ${({ $isSwitch, $isRecordLinks }) => ($isSwitch ? 'auto' : $isRecordLinks ? '98%' : '50%')};

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  ${({ $isMatrix, $isRiskTemplate }) =>
    $isMatrix &&
    css`
      cursor: pointer;
      padding: ${$isRiskTemplate ? '8 12' : 0}px;
      min-height: ${$isRiskTemplate ? '64' : 48}px;

      ${ClockIconButton} {
        margin-top: 0 !important;
      }
    `};

  ${({ $color }) =>
    $color &&
    css<{ $color: string }>`
      color: ${isColorLight($color) ? colors.black : colors.white};
      font-weight: bold;
      font-size: 16px;

      > svg {
        path {
          fill: ${isColorLight($color) ? colors.black : colors.white};
        }
      }
    `};

  && {
    .switch-wrapper {
      min-height: 48px;
      display: flex;
      align-items: center;
    }
  }

  ${ButtonsWrapper} {
    right: 5px;
  }

  .MuiFormLabel-root {
    position: static;
    white-space: unset;
    margin-bottom: -8px;
  }

  .MuiInputBase-root {
    margin-top: 0;
  }

  .location-select-wrapper {
    margin-top: 0;
  }

  ${SelectWrapper} {
    margin-top: 0;
  }

  ${AiButtonsWrapper} {
    display: none;
  }

  &:hover {
    ${AiButtonsWrapper} {
      ${({ $historyEnabled }) => $historyEnabled && `right: 62px;`}
      display: flex;
    }
  }
`
